// extracted by mini-css-extract-plugin
export default {"form":"sign-in_form__nbP3O","forgotPassword":"sign-in_forgotPassword__Ms94i","actions":"sign-in_actions__MUgM7"};